// src/utils/postMessage.utils.ts

type MessageType = string;
type MessagePayload = any;

export const postToParent = (type: MessageType, payload: MessagePayload) => {
  console.log("post msg to parent", type, payload);
  window.parent.postMessage({ type, payload }, '*');
};

export const listenToParentMessages = (handler: (event: MessageEvent) => void) => {
  window.addEventListener('message', handler);
  return () => window.removeEventListener('message', handler);
};
 